<template>
  <header>
    <nav id="navigation">
      <Herramientas v-if="abrirHerramientas"></Herramientas>
      <section v-show="!$store.state.ocultarBarra" class="right">
        <!-- <a>
          <i class="icon-star color-3"></i>
        </a> -->
        <a>
          <i
            @click="abrirHerramientas = !abrirHerramientas"
            :class="{'icon-wrench':true, 'color-11':!abrirHerramientas, 'color-6':abrirHerramientas}"
          ></i>
        </a>
        <a v-if="config.mostrarCreditos && !abrirHerramientas">
          <i @click.stop="setModalCredits(true)" class="icon-copyright color-11"></i>
        </a>
        <a v-if="config.descargarJSON" style="top:-6px">
          <i @click.stop="downloadJSON()" class="fa fa-cloud-download-alt"></i>
        </a>
      </section>
    </nav>
    
  </header>
</template>

<script>
import Herramientas from "./herramientas/Herramientas";
import { mapState, mapMutations } from "vuex";

export default {
  name: "Header",
  components: {
    Herramientas
  },
  data: () => ({
    abrirHerramientas: false,
  }),
  methods: {
    downloadJSON(){
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.zonasActivas));
      var a = document.createElement('a');
      a.setAttribute("href",     dataStr);
      a.setAttribute("download", "ZonasActivas.json");
      a.click();
      a.remove();
    },
    ...mapMutations(['setModalCredits'])
  },
  computed:{
    ...mapState(['config', 'zonasActivas'])
  }
};
</script>
